import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-chronoblog/src/components/page/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const FeedItems = makeShortcode("FeedItems");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div style={{
      paddingLeft: 10
    }}>
  <i style={{
        fontSize: 18
      }}>
    Software engineer <a href="https://www.sfox.com/">@SFOX</a>.<br />
    Contributor to the <a href="https://medium.com/linebyline">Line by Line blog</a>.
  </i>
  <br /><br />
  <h3>Posts&nbsp;&nbsp;</h3>
  <FeedItems itemsFormat="compact" filterByTags={['post', 'article']} limit={4} mdxType="FeedItems" />
  <br />
  <h3>Projects&nbsp;&nbsp;</h3>
  <FeedItems itemsFormat="compact" filterByTags={['project']} limit={4} mdxType="FeedItems" />
  <p>&nbsp;</p>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      